import React from 'react';

import classes from './Loader.module.css';

const Loader = () => (
    <div className={classes.loading}></div>
);

export default Loader;